import { storageLanguage } from "helpers";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { languages } from "../../../i18next";

const Locales = () => {
  const { i18n } = useTranslation();
  const [language, setLanguage] = useState(storageLanguage());

  const onChangeLang = (lang) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
  };

  const getLanguageLabel = (lang) => {
    switch (lang.toLowerCase()) {
      case "ru": return "РУС";
      case "kk": return "КАЗ";
      case "en": return "ENG";
      default: return lang.toUpperCase();
    }
  };

  return (
    <div className="flex items-center gap-1">
      {languages.map((e, index) => (
        <React.Fragment key={e}>
          <button
            onClick={() => onChangeLang(e)}
            className={`font-semibold uppercase transition-colors duration-300 ease-in-out text-[11px] md:text-[12px] bg-transparent border-none outline-none focus:outline-none p-0 m-0 shadow-none ${
              language === e
                ? "text-emerald-500"
                : "text-gray-800 hover:text-emerald-500"
            }`}
          >
            {getLanguageLabel(e)}
          </button>
          {index < languages.length - 1 && (
            <span className="text-gray-400 font-light text-sm">|</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Locales;
